import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProductGallery from "../components/ProductGallery";
import ProductInfo from "../components/ProductInfo";
import BuyBox from "../components/BuyBox";
import { trackEvent } from "../utils/analytics";
import { useVehicle } from "../context/VehicleContext";



function ProductScreen() {
  const { listingId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [crossSell, setCrossSell] = useState([]);
const { selectedVehicle } = useVehicle();


  const usesVariants = useMemo(() =>
    product?.variants?.length > 0,
    [product]
  );

  const selectedVariant = useMemo(() =>
    usesVariants
      ? product?.variants?.find(v => v.condition === selectedCondition)
      : null,
    [product, selectedCondition, usesVariants]
  );

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(`https://eleven11-i6v4.onrender.com/api/listings/${listingId}`);
        if (!res.ok) throw new Error("Listing not found");
        const data = await res.json();
        setProduct(data);

        if (data.variants?.length > 0) {
          const cheapest = [...data.variants].sort((a, b) => a.price - b.price)[0];
          setSelectedCondition(cheapest.condition);
        }

        trackEvent("product_view", {
          listingId: data.listingId,
          listingTitle: data.title
        });

      } catch (err) {
        setProduct(false);
      }
    };

    fetchProduct();
  }, [listingId]);

useEffect(() => {
  let url = "https://eleven11-i6v4.onrender.com/api/listings";

  if (selectedVehicle) {
    const params = new URLSearchParams({
      year: selectedVehicle.year,
      manufacturer: selectedVehicle.manufacturer,
      model: selectedVehicle.model,
    });
    url += `?${params.toString()}`;
  }

  fetch(url)
    .then(res => res.json())
    .then(data => {
   const CROSS_SELL_CATEGORIES = [
  "Fluids & Maintenance",
  "Lubricants & Sprays",
  "Marine Detailing"
];

const others = data.filter(l =>
  l.listingId !== listingId &&
  l.images?.length > 0 &&
  CROSS_SELL_CATEGORIES.includes(l.category)
);


      const shuffled = [...others].sort(() => Math.random() - 0.5);
      setCrossSell(shuffled.slice(0, 5));
    })
    .catch(() => {});
}, [listingId, selectedVehicle]);



  if (product === false) {
    return <div style={{ padding: 40 }}>Listing not found.</div>;
  }

  if (!product) {
    return <div style={{ padding: 40 }}>Loading product...</div>;
  }

  return (
    <div style={styles.page}>

      {/* Main Product Grid */}
      <div style={styles.container}>
        <div style={styles.gallery}>
       <ProductGallery images={(selectedVariant?.images?.length > 0 ? selectedVariant.images : product.images) || []} />
        </div>
        <div style={styles.info}>
          <ProductInfo
            product={product}
            selectedCondition={selectedCondition}
            setSelectedCondition={setSelectedCondition}
            selectedVariant={selectedVariant}
            usesVariants={usesVariants}
          />
        </div>
        <div style={styles.buyBox}>
          <BuyBox
            product={product}
            selectedCondition={selectedCondition}
            selectedVariant={selectedVariant}
            usesVariants={usesVariants}
          />
        </div>
      </div>

      {/* Bought Together Rail */}
      {crossSell.length > 0 && (
        <div style={styles.railWrap}>
          <div style={styles.railHeader}>
            <div>
              <p style={styles.railKicker}>CUSTOMERS ALSO BOUGHT</p>
              <h2 style={styles.railTitle}>Complete Your Setup</h2>
            </div>
          </div>

          <div style={styles.railGrid}>
         {crossSell.map(item => {
  const variant = item.variants?.[0];
  const price = variant?.price ?? item.price ?? 0;
  const condition = variant?.condition ?? item.condition ?? "used";

  return (
    <div
      key={item._id}
      style={styles.railCard}
      onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
      onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
    >
      {/* Clickable image + info */}
      <div
        onClick={() => navigate(`/product/${item.listingId}`)}
        style={{ cursor: "pointer" }}
      >
        <div style={styles.railImageWrap}>
          <img
            src={`${item.images[0]}`}
            alt={item.title}
            style={styles.railImage}
          />
        </div>
        <div style={styles.railInfo}>
          <p style={styles.railCategory}>{item.category}</p>
          <p style={styles.railName}>{item.title}</p>
          <p style={styles.railPrice}>${Number(price).toFixed(2)}</p>
        </div>
      </div>

      {/* Add to Cart */}
      <div style={{ padding: "0 16px 14px" }}>
    <button
    
  style={styles.railCartBtn}
  onMouseEnter={e => {
    e.currentTarget.style.background = "#2d2d2d";
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
  }}
  onMouseLeave={e => {
    e.currentTarget.style.background = "#0f0f17";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  }}
  onClick={async (e) => {

            e.stopPropagation();
            try {
              await fetch("https://eleven11-i6v4.onrender.com/api/cart", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  productId: item.listingId,
                  qty: 1,
                  selectedCondition: condition,
                  selectedVariant: variant || null,
                  price: Number(price)
                })
              });
              trackEvent("add_to_cart", {
                listingId: item.listingId,
                listingTitle: item.title
              });
              e.target.innerText = "✓ Added";
              e.target.style.background = "#EDFDF4";
              e.target.style.color = "#15803D";
              setTimeout(() => {
                e.target.innerText = "Add to Cart";
                e.target.style.background = "#0f0f17";
                e.target.style.color = "#fff";
              }, 2000);
            } catch {}
          }}
        >
          Add to Cart
        </button>
      </div>

    </div>
  );
})}
          </div>
        </div>
      )}

    </div>
  );
}

const styles = {
  page: {
    padding: 40,
    fontFamily: "-apple-system, BlinkMacSystemFont, system-ui",
    background: "#F6F7FB",
    minHeight: "100vh"
  },
  container: {
    display: "grid",
    gridTemplateColumns: "450px 1fr 320px",
    gap: 40,
    maxWidth: 1400,
    margin: "0 auto"
  },
  gallery: {},
  info: {},
  buyBox: {},

  /* Rail */
  railWrap: {
    maxWidth: 1400,
    margin: "60px auto 0",
  },
  railHeader: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBottom: 24
  },
  railKicker: {
    margin: 0,
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 2,
    color: "#9ca3af",
    textTransform: "uppercase"
  },
  railTitle: {
    margin: "6px 0 0",
    fontSize: 26,
    fontWeight: 800,
    letterSpacing: -0.5,
    color: "#0f0f17"
  },
  railGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: 16
  },

railCartBtn: {
  width: "100%",
  padding: "9px 0",
  border: "none",
  borderRadius: 10,
  background: "#0f0f17",
  color: "#fff",
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  transition: "all 0.2s ease"
},


  railCard: {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 8px 24px rgba(0,0,0,0.04)"
  },
  railImageWrap: {
    width: "100%",
    aspectRatio: "1",
    background: "#f9fafb",
    overflow: "hidden"
  },
  railImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  railInfo: {
    padding: "14px 16px"
  },
  railCategory: {
    margin: 0,
    fontSize: 10,
    fontWeight: 700,
    color: "#9ca3af",
    textTransform: "uppercase",
    letterSpacing: 1
  },
  railName: {
    margin: "5px 0 8px",
    fontSize: 13,
    fontWeight: 600,
    color: "#0f0f17",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  railPrice: {
    margin: 0,
    fontSize: 15,
    fontWeight: 800,
    color: "#0f0f17"
  }
};

export default ProductScreen;  